@if (!inlineMap() && showMap && !isDateFlow()) {
  <ush-modal-map
    class="performance-map"
    [inlineMap]="false"
    [lat]="perfGroup.cinema.latitude"
    [lng]="perfGroup.cinema.longitude"
    [address]="addressExists() ? perfGroup.cinema.place.address : ''"
    (hide)="onHideMap()"
  />
}

<div class="panel-showtimes ush-cinema-content">
  <div class="panel-content">
    @if (!hideAddress) {
      @if ((perfGroup.cinema.place.address || perfGroup.cinema.place?.city?.name) && !isDateFlow()) {
        <div class="cinema-location">
          @if (perfGroup.cinema.latitude && perfGroup.cinema.longitude) {
            @if (!inlineMap() || (inlineMap() && !showMap)) {
              <a
                class="ush-cinema-open-map"
                role="button"
                tabindex="0"
                (click)="openMap()"
                (keydown)="openMapKeydown($event)"
              >
                <fa-icon [icon]="locationIcon" class="map-icon ush-cinema-map-icon"></fa-icon>
                <span>{{ perfGroup?.cinema?.place?.address }} {{ perfGroup?.cinema?.place?.city?.name }}</span>
              </a>
            }
          } @else {
            <div class="cinema-address ush-cinema-address">
              @if (addressExists()) {
                <fa-icon [icon]="locationIcon" class="ush-cinema-address-marker"></fa-icon>
                <span class="ush-cinema-address--place">{{ perfGroup.cinema.place.address }}</span
                >,
                <span class="ush-cinema-address--city">{{ perfGroup.cinema.place.city.name }}</span>
              }
            </div>
          }

          <!-- CLOSE INLINE MAP -->
          @if (inlineMap() && showMap) {
            <a class="ush-cinema-close-map" style="margin-left: auto" (click)="closeInlineMap()">
              <fa-icon [icon]="closeIncon" class="map-icon ush-cinema-map-icon"></fa-icon>
            </a>
          }
        </div>
      }
    }

    @if (inlineMap() && !isDateFlow() && showMap) {
      <div class="inlineMap">
        <ush-modal-map
          class="performance-map"
          [inlineMap]="true"
          [lat]="perfGroup.cinema.latitude"
          [lng]="perfGroup.cinema.longitude"
          [address]="addressExists() ? perfGroup.cinema.place.address : ''"
          (hide)="onHideMap()"
        >
        </ush-modal-map>
      </div>
    }

    <div class="showtime-dates">
      @if (!isDateFlow()) {
        <ush-dates-carousel [dates]="dates()" (itemSelected)="setHours($event)" />
      }
      <div class="hours-wrapper">
        @if (!activatedPlaceholderHours()) {
          @for (hour of hours(); track $index) {
            <ush-ui-hour [hour]="hour" (hourSelected)="changeHour(hour)"></ush-ui-hour>
          }
        } @else {
          @for (hour of placeholderHoursList; track $index) {
            <div class="hour-placeholder"></div>
          }
        }
      </div>
    </div>
  </div>
</div>
